module.exports = __webpack_public_path__ + "static/media/gmc_icn_landing_card_2.8e0d597d.svg";